/**
 * Runtime Tenant Configuration
 *
 * This module provides tenant-specific branding and configuration
 * that can be overridden at runtime via window.__TENANT_CONFIG__
 */

// Default TPL configuration (fallback)
const defaultConfig = {
  tenantId: 'tpl',
  name: 'TPL GIS Assistant',
  shortName: 'TPL',
  tagline: 'Natural language queries for your GIS data',
  logo: {
    text: 'TPL',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
  },
  theme: {
    primaryColor: '#3b82f6',
    primaryDark: '#1d4ed8',
    backgroundGradient: 'linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 100%)',
  },
  accessRestriction: '@codvo.ai',
};

// Tenant-specific configurations
const tenantConfigs = {
  tpl: defaultConfig,

  'nexus-oilgas': {
    tenantId: 'nexus-oilgas',
    name: 'Nexus GIS',
    shortName: 'Nexus',
    tagline: 'AI-Powered Oil & Gas Asset Intelligence',
    logo: {
      text: 'N',
      gradient: 'linear-gradient(135deg, #FF6B00 0%, #E55A00 100%)',
    },
    theme: {
      primaryColor: '#FF6B00',
      primaryDark: '#E55A00',
      backgroundGradient: 'linear-gradient(135deg, #1A1A2E 0%, #0F0F1A 100%)',
    },
    accessRestriction: null, // Demo mode - no restriction shown
  },

  'nexus-lng': {
    tenantId: 'nexus-lng',
    name: 'Nexus LNG',
    shortName: 'LNG',
    tagline: 'Global LNG Asset Intelligence Platform',
    logo: {
      text: 'LNG',
      gradient: 'linear-gradient(135deg, #00BCD4 0%, #006064 100%)',
    },
    theme: {
      primaryColor: '#00BCD4',
      primaryDark: '#006064',
      backgroundGradient: 'linear-gradient(135deg, #004D40 0%, #00251A 100%)',
    },
    accessRestriction: null, // Demo mode - no restriction shown
  },
};

/**
 * Get tenant configuration
 * Priority: window.__TENANT_CONFIG__ > URL-based detection > default
 */
export function getTenantConfig() {
  // 1. Check for runtime injected config
  if (window.__TENANT_CONFIG__) {
    return { ...defaultConfig, ...window.__TENANT_CONFIG__ };
  }

  // 2. Detect tenant from hostname
  const hostname = window.location.hostname;

  if (hostname.includes('nexus-oilgas')) {
    return tenantConfigs['nexus-oilgas'];
  }
  if (hostname.includes('nexus-lng')) {
    return tenantConfigs['nexus-lng'];
  }

  // 3. Check for tenant in URL path (e.g., /tenant/nexus-oilgas/)
  const pathMatch = window.location.pathname.match(/^\/tenant\/([^/]+)/);
  if (pathMatch && tenantConfigs[pathMatch[1]]) {
    return tenantConfigs[pathMatch[1]];
  }

  // 4. Default to TPL
  return defaultConfig;
}

/**
 * Get current tenant ID
 */
export function getTenantId() {
  return getTenantConfig().tenantId;
}

export default getTenantConfig;
